<template>
  <div class="node-certificate">
    <action-bar>
      <btn-style :btn-list="btnList"></btn-style>
      <!-- <query-assembly @getList="getList"></query-assembly> -->
    </action-bar>

    <normal-table ref="commonTable" :table-col="tableCol" :table-data="list" :first-table-col="firstTableCol"
      :operator="operator" :operate-col="operateCol" :show-edit="true" :paging="paging" 
      @pagination="handleSizeOrPageChange">
    </normal-table>
    <gen-node-user-cert ref="genNode" @update:list="getList()"></gen-node-user-cert>
    <show-cert-dialog ref="seeDialog"></show-cert-dialog>
  </div>
</template>

<script>
import genNodeUserCert from './components/genNodeUserCert'
import showCertDialog from './components/showCertDialog'
import auth from '@/auth/index'

export default {
  name: 'NodeUserCerts',
  components: {
    genNodeUserCert,
    showCertDialog
  },
  data() {
    return {
      btnList: [
        {
          btnContent: '生成节点用户证书',
          click: () => {
            return this.genNodeUserCert()
          },
          auth: auth.certificate.publicKeyAuth.nodeUserCert.createNodeUserCert,
          icon: 'icon-gen'
        }
      ],
      // 设置table的列
      tableCol: [
        { 
          prop: 'NodeID', 
          label: '节点ID',
          minWidth: 217, 
        },
        { 
          prop: 'NodeName', 
          label: '节点名称',
          minWidth: 186, 
        },
        {
          prop: 'AuthType',
          label: '认证模式',
          minWidth: 188,
          formatter: row => {
            return this.formatAuthType(row.AuthType)
          }
        },
        {
          prop: 'PubKeyAlgo',
          label: '密码算法',
          minWidth: 174,
          formatter: row => {
            return this.formatAlgo(row.PubKeyAlgo)
          }
        },
        {
          prop: 'createAt',
          label: '创建时间',
          minWidth: 244,
          formatter: row => {
            return this.formatTime(row)
          }
        }
      ],
      // table的基本操作
      operator: [
        {
          text: '查看公钥',
          showText: true,
          click: (row, col, cellValue) => {
            return this.getInfo(row)
          },
          icon: 'icon-check'
        },
        {
          text: '下载',
          showText: true,
          click: (row, col, cellValue) => {
            return this.downloadFile(row)
          },
          icon: 'icon-download'
        }
      ],
      operateCol: {
        minWidth: 158
      },
      firstTableCol: {
        select: false,
        type: 'selection'
      },
      list: [],
      paging: {
        offset: 0,
        limit: 10,
        total: 0,
        totalPages: 0
      }
    }
  },
  mounted() {
    this.getList()
  },
  methods: {
    getList(limit = 10, offset = 0, name) {
      let params = {
        offset,
        limit,
        name
      }
      let self = this;
      this.$apis.certificate
        .getDposNodeUserCerts(params)
        .then(response => {
          if (response && response.data) {
            self.list = response.data.items;
            self.paging.limit = response.data.limit;
            self.paging.offset = response.data.offset;
            self.paging.total = response.data.total;
            self.paging.totalPages = Math.ceil(self.paging.total / self.paging.limit);
          }
        })
        .catch(error => Promise.reject(error))
    },
    handleSizeOrPageChange(data) {
      const { offset, limit } = data
      this.getList(limit, offset * limit)
    },
    formatTime(row) {
      return this.$utils.dateFormat('YYYY-mm-dd HH:MM', row.createAt)
    },
    formatAlgo(algo) {
      switch (algo) {
        case 0:
          return '国密'
        case 1:
          return 'ECDSA'
        default:
          return this.$constants.EMPTY
      }
    },
    formatAuthType(type) {
      return 'public'
    },
    genNodeUserCert() {
      this.$refs.genNode.handleOpen()
    },
    getInfo(row) {
      let data = {
        cert: [{
          title: '节点公钥',
          content: row.NodePublicKey,
          downloadName: `${row.NodeName}-node`
        }, {
          title: '用户公钥',
          content: row.UserPublicKey,
          downloadName: `${row.NodeName}-user`
        }],
        title: '查看公钥'
      }

      this.$refs.seeDialog.handleOpen(data)
    },
    downloadFile(row) {
      const nFileName = `${row.NodeName}-node.key`
      this.$utils.createFileAndDownload(nFileName, row.NodePublicKey)

      const uFileName = `${row.NodeName}-user.key`
      this.$utils.createFileAndDownload(uFileName, row.UserPublicKey)
    },
    refresh() {
      const { offset, limit } = this.paging
      this.getList(limit, offset)
    }
  }
}
</script>

<style scoped lang="scss">
@import '@/styles/variables/theme';
@import '@/styles/variables/adaptation';
.node-certificate {
  @include adaptation(
    (
      --node-certificate-list-unavailable-height: 111px,
    )
  );
  --node-certificate-list-min-height: calc(var(--base-main-router-body-avaliable-height) - var(--node-certificate-list-unavailable-height));
  .normal-table-wrap {
    height: 100%;
    min-height: var(--node-certificate-list-min-height);

    /deep/ {
      .el-empty {
        height: 100%;
        min-height: var(--node-certificate-list-min-height);
      }

      .normal-table {
        height: 100%;
        min-height: var(--node-certificate-list-min-height);
      }
    }
  }
}
</style>
